import React, { useEffect, useContext} from "react";
import { useParams } from "react-router-dom";
import AdminLayout from "../../components/layout/AdminLayout";
import { Helmet } from "react-helmet-async";
import LoadingSpinner from "../../components/utilities/LoadingSpinner";
import LeloForm from "../../components/leloAdmin/LeloForm";
import AdminLeloContext from "../../context/adminLelo/adminLeloContext";

const LeloFormPage = () => {
  const { id } = useParams();
  const adminLeloContext = useContext(AdminLeloContext);
  const { getLeloEntrie, Leloentrie } = adminLeloContext;

  useEffect(() => {
    getLeloEntrie(id);
  }, []);
  return (
    <AdminLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Request Information</title>
      </Helmet>
      <div id="interest-form-page">
        <div className="container">
          {Object.keys(Leloentrie).length !== 0 ? (
            <LeloForm formData={Leloentrie} />
          ) : (
            <LoadingSpinner />
          )}
        </div>
      </div>
    </AdminLayout>
  );
};
export default LeloFormPage;
